import { type ItemPaging } from "@ca.vmedia.tv/domains";
import { Strings } from "@/locales/types/enums";
import { ShowAllCardData, type CardData, PlusCardData } from "@/components/Cards/types";

interface IItems {
    getClass?: () => string;
}

interface ExposeInterface {
    hasShowAll: (paging: ItemPaging | null) => boolean;
    getCardShowAll: (<T extends IItems>(items: T[],  paging: ItemPaging | null) => ShowAllCardData[]);
    getCardPlus: (itemClass: string,  keyCaption: keyof typeof Strings) => CardData[];
}

export const useExtraCards = (): ExposeInterface => {
    const { $i18n } = useNuxtApp();
    const hasShowAll = (paging: ItemPaging | null): boolean => paging !== null && paging.totalItems !== null && paging.itemsOnPage !== null ? paging.totalItems > paging.itemsOnPage : false;

    const getCardShowAll = <T extends IItems>(items: T[],  paging: ItemPaging | null): ShowAllCardData[] => {
        if (items.length === 0 || items[0] === undefined) {
            console.error("Items array is empty or undefined");
            return [];
        }
        const itemClass = items[0].getClass?.() ?? '';
        const name = `${$i18n.t(Strings.SHOW_ALL).toString()} (${paging?.totalItems})`;

        return [new ShowAllCardData(itemClass, name)];
    };

    const getCardPlus = (itemClass: string,  keyCaption: keyof typeof Strings): CardData[] => {
        return [new PlusCardData(itemClass, $i18n.t(Strings[keyCaption]).toString())];
    };
    return {
        hasShowAll,
        getCardShowAll,
        getCardPlus
    }
};
